var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["widget-block", _vm.componentClass] },
    [
      _vm.widgetInfo.widgetName !== "import-users"
        ? _c(
            "div",
            {
              staticClass:
                "row no-gutters py-2 px-3 text-white rounded-top bg-ltblue"
            },
            [
              _c("div", { staticClass: "col-6 d-inline-block widget-title" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.widgetInfo.widgetTitle) + "\n    "
                )
              ]),
              _vm._v(" "),
              _vm.widgetInfo.route
                ? _c(
                    "div",
                    {
                      staticClass:
                        "col-6 d-inline-block text-right smaller-font-content"
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "align-middle text-white",
                          attrs: { to: { name: _vm.widgetInfo.route } }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.widgetInfo.linkTitle))
                          ]),
                          _c("i", { staticClass: "fas fa-angle-right ml-1" })
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.widgetInfo.widgetName === "import-users"
        ? _c("importusers-block", { attrs: { widgetInfo: _vm.widgetInfo } })
        : _vm._e(),
      _vm._v(" "),
      _vm.widgetInfo.widgetName === "upload-users"
        ? _c("uploadusers-block", {
            staticClass: "px-3 my-2",
            attrs: { widgetInfo: _vm.widgetInfo }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.widgetInfo.widgetName === "download-file"
        ? _c("downloadfile-block", {
            staticClass: "px-3 my-2",
            attrs: { widgetInfo: _vm.widgetInfo }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "widget-loader" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isLoading,
                expression: "isLoading"
              }
            ],
            staticClass: "loader-content text-center"
          },
          [
            _c("i", { staticClass: "fas fa-circle-o-notch fa-spin mr-1" }),
            _vm._v("Loading…\n    ")
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31e88d27", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31e88d27","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/widgets/BlockWidget.vue
// module id = null
// module chunks = 